/* eslint @next/next/no-sync-scripts: "off" */
import { memo } from 'react';
import Head from 'next/head';

/**
 * Bid Barrel Script Only
 * @category Functional Component
 * @summary Includes the BidBarrel script and bootstrap only for pages without ads but need to utilize bidbarrel funtions.
 * @return {Node} React node containing the script and bootstrap for bid barrel.
 */

const BidBarrelScriptOnly = () => {
  return (
    <Head>
      <script dangerouslySetInnerHTML={{ __html: `
        (function(a){
          var w=window,b='BidBarrel',q='queue';w[b]=w[b]?w[b]:{};w[b][q]=w[b][q]?w[b][q]:[];
          a.forEach(function(z){w[b][z]=w[b][z]||function(){var c=arguments;w[b][q].push(function(r){w[b][z].apply(w[b],c);r()})}});
        })([]);
      `}} />
      <script src={ process.env.NEXT_PUBLIC_BID_BARREL_URL } />
    </Head>
  );
}

export default memo(BidBarrelScriptOnly);
